import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/FoundingMembers.jsx");
